import { LEGAL_AGENT } from '../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../helpers/features/featureFlags';
import { verify_subscription } from '../../utils';

/**
 * Whether the organization can use the Legal Agent: the `legalAgent` flag and a premium
 * subscription, matching the backend's gate on the Legal Agent routes.
 */
export function useIsLegalAgentEnabled(): boolean {
  const isFlagEnabled = useIsFeatureEnabled(LEGAL_AGENT);
  return isFlagEnabled && verify_subscription('premium');
}
